
export const RICERCA_ISCRIZIONE = "RICERCA_ISCRIZIONE"
export const RICERCA_ISCRIZIONE_SUCCESS = "RICERCA_ISCRIZIONE_SUCCESS"

export const RICERCA_COMUNI = "RICERCA_COMUNI"
export const RICERCA_COMUNI_SUCCESS = "RICERCA_COMUNI_SUCCESS"

export const RESET_ANAGRAFE_STATE = "RESET_ANAGRAFE_STATE"